document.addEventListener('DOMContentLoaded', () => {
  const contentBlocks = document.querySelectorAll('.blog-grid-card__content');

  contentBlocks.forEach((content) => {
    content.addEventListener('click', (event) => {
      /* Prevent click from bubbling to parent link (if any) */
      event.preventDefault();
      event.stopPropagation();

      content.classList.toggle('expanded');
    });
  });
});
